module.exports = __webpack_public_path__ + "static/media/cardAsusp.eb038c9f.svg";